import { useState } from 'react';
import { useAbility } from '@/hooks/useAbility';
import {
  languageFollowsCountry,
  nextVenueLanguage,
  type LanguageCode,
} from '../lib/venue-language';

type SavedRestaurant = { country: string };
type SavedFranchise = { id: string; restaurantCount: number; defaultLanguage: LanguageCode };

export function useVenueLanguage(
  restaurant: SavedRestaurant | undefined,
  franchise: SavedFranchise | undefined,
) {
  const followCountry = languageFollowsCountry(useAbility(), franchise);

  const [chosen, setChosen] = useState<LanguageCode | null>(null);
  const [pickedByHand, setPickedByHand] = useState(false);
  const language = chosen ?? franchise?.defaultLanguage ?? 'de';

  function pickLanguage(code: LanguageCode) {
    setChosen(code);
    setPickedByHand(true);
  }

  function followCountryChange(nextCountry: string) {
    if (!followCountry || !restaurant || !franchise) return;
    const saved = { country: restaurant.country, language: franchise.defaultLanguage };
    setChosen(nextVenueLanguage(saved, nextCountry, language, pickedByHand));
  }

  const languageDirty = !!franchise && language !== franchise.defaultLanguage;

  return { language, languageDirty, pickLanguage, followCountryChange };
}
